import * as tslib_1 from "tslib";
import { OnInit, ViewContainerRef } from '@angular/core';
import { environment } from '../../../environment';
import { MapService } from '../../../services/map.service';
import { BaseComponent } from '../../base.component';
var MapPickerComponent = /** @class */ (function (_super) {
    tslib_1.__extends(MapPickerComponent, _super);
    function MapPickerComponent(_vcr, mapService, authService) {
        var _this = _super.call(this, _vcr, true) || this;
        _this.mapService = mapService;
        _this.applicationId = environment.appId;
        authService.user.subscribe(function () {
            _this.loadMaps();
        });
        return _this;
    }
    Object.defineProperty(MapPickerComponent.prototype, "category", {
        get: function () {
            return this._category;
        },
        set: function (value) {
            this._category = value;
            this.filterMaps(value);
        },
        enumerable: true,
        configurable: true
    });
    MapPickerComponent.prototype.ngOnInit = function () {
        this.loadMaps();
    };
    MapPickerComponent.prototype.loadMaps = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result, error_1;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        return [4 /*yield*/, this.mapService.getSystemMaps(this.applicationId, false)];
                    case 1:
                        result = _a.sent();
                        this.maps = result[0].maps;
                        this.loadCategories();
                        this.category = this.config.category;
                        this.map = this.maps.find(function (m) { return m.name === _this.config.map; });
                        return [3 /*break*/, 4];
                    case 2:
                        error_1 = _a.sent();
                        this.readyProblem(error_1);
                        return [3 /*break*/, 4];
                    case 3:
                        this.isReady();
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    MapPickerComponent.prototype.loadCategories = function () {
        this.categories = new Set(this.maps.map(function (m) { return m.categories; }).flat().map(function (c) { return c.name; }));
    };
    MapPickerComponent.prototype.filterMaps = function (category) {
        this.filteredMaps = this.maps.filter(function (m) { return m.categories.map(function (c) { return c.name; }).includes(category); });
        this.filteredMaps.unshift({ name: '<No Starter Map>' });
        this.map = this.filteredMaps[0];
    };
    return MapPickerComponent;
}(BaseComponent));
export { MapPickerComponent };
